import { FC, ReactNode } from 'react';

import Clock from '@/components/Clock.tsx';
import Heading1 from '@/components/text/Heading1.tsx';

interface Props {
    title?: string;
    middleComponent?: ReactNode;
    showClock?: boolean;
    ctaButton?: ReactNode;
}

const PageTitleBar: FC<Props> = ({ title, middleComponent, showClock = true, ctaButton }) => {
    return (
        <div className="flex w-full items-center justify-between gap-4">
            {title && <Heading1 className="mr-4 text-4xl font-semibold">{title}</Heading1>}
            {middleComponent && <div className="flex flex-grow items-center justify-end">{middleComponent}</div>}
            <div className="flex items-center gap-2">
                {showClock && <Clock />}
                {ctaButton}
            </div>
        </div>
    );
};

export default PageTitleBar;
